import { useEffect } from "react";
import { useDispatch } from "noval";
import { useRouter } from "next/router";
import { getCookie, getToken } from "@network/http";
import useTranslation from "next-translate/useTranslation";
export const useSafeRouting = (isPublicRoute, isHybridRoute) => {
  const { dispatch } = useDispatch();
  const { push, asPath } = useRouter();
  const { lang } = useTranslation();
  useEffect(() => {
    const savedLang = lang || getCookie("NEXT_LOCALE");
    const token = getToken();
    if (isPublicRoute && token) push(`/${savedLang}/home`);
    else if (!isPublicRoute && !isHybridRoute && !token) {
      dispatch({ savedPath: asPath });
      push(`/${savedLang}/login`);
    }
  }, [isPublicRoute, isHybridRoute]);
};
